'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _playback = require('../../base/playback');

var _playback2 = _interopRequireDefault(_playback);

var _template = require('../../base/template');

var _template2 = _interopRequireDefault(_template);

var _browser = require('../../components/browser');

var _browser2 = _interopRequireDefault(_browser);

var _flash = require('./public/flash.html');

var _flash2 = _interopRequireDefault(_flash);

require('./public/flash.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IE_CLASSID = 'clsid:d27cdb6e-ae6d-11cf-96b8-444553540000'; // Copyright 2015 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

var BaseFlashPlayback = function (_Playback) {
  (0, _inherits3.default)(BaseFlashPlayback, _Playback);

  function BaseFlashPlayback() {
    (0, _classCallCheck3.default)(this, BaseFlashPlayback);
    return (0, _possibleConstructorReturn3.default)(this, (BaseFlashPlayback.__proto__ || (0, _getPrototypeOf2.default)(BaseFlashPlayback)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseFlashPlayback, [{
    key: 'setElement',
    value: function setElement(element) {
      this.$el = element;
      this.el = element[0];
    }
  }, {
    key: 'render',
    value: function render() {
      this.$el.attr('data', this.swfPath);
      this.$el.html(this.template({
        cid: this.cid,
        swfPath: this.swfPath,
        baseUrl: this.baseUrl,
        playbackId: this.uniqueId,
        wmode: this.wmode,
        callbackName: 'window.Clappr.flashlsCallbacks.' + this.cid }));

      if (_browser2.default.isIE) {
        this.$('embed').remove();

        if (_browser2.default.isLegacyIE) this.$el.attr('classid', IE_CLASSID);
      }

      this.el.id = this.cid;

      return this;
    }
  }, {
    key: 'tagName',
    get: function get() {
      return 'object';
    }
  }, {
    key: 'swfPath',
    get: function get() {
      return '';
    }
  }, {
    key: 'wmode',
    get: function get() {
      return 'transparent';
    }
  }, {
    key: 'template',
    get: function get() {
      return (0, _template2.default)(_flash2.default);
    }
  }, {
    key: 'attributes',
    get: function get() {
      var type = 'application/x-shockwave-flash';

      if (_browser2.default.isLegacyIE) type = '';

      return {
        class: 'clappr-flash-playback',
        type: type,
        width: '100%',
        height: '100%',
        data: this.swfPath,
        'data-flash-playback': this.name
      };
    }
  }]);
  return BaseFlashPlayback;
}(_playback2.default);

exports.default = BaseFlashPlayback;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/playbacks/base_flash_playback/base_flash_playback.js
// module id = 259
// module chunks = 0